<template>
  <div class="columns is-multiline is-variable is-mobile is-5">
    <cell-component
      v-for="(item_key, index) in item_keys"
      :key="item_key"
      :item="getItemForKey(item_key)"
      :layoutClasses="layoutClasses && layoutClasses[index]">
    </cell-component>
  </div>
</template>
<script>
  import CellComponent from './CellComponent'
  import { getDetailDisplayContext } from '@/utility/utility_functions'
  import { DisplayContextError } from '@/classes/errors'
  export default {
    components: { CellComponent },
    name: 'grid-details-component',
    props: {
      item: {
        type: Object,
        required: true
      },
      item_keys: {
        type: Array,
        required: true
      },
      display_spec: {
        type: Array,
        required: true
      },
      layoutClasses: {
        type: Array
      }
    },
    computed: {
      trContext () {
        return getDetailDisplayContext(this.item, this.display_spec)
      }
    },
    methods: {
      getItemForKey (key) {
        let item = this.trContext.find(i => i.item_key === key)
        if (item === undefined) {
          throw new DisplayContextError(`No item found for key: ${key}`)
        }
        return item
      }
    }
  }
</script>
